import { View, Utils } from '../vendor/kerneljs';

const StylishTable = View.extend({

	initialize: function(){
		this.lastScrolled = 0;
		this.scrolledDown = 0;
		this.scrolledUp = 0;
		

		Utils.on(window, 'scroll', this.siteScrollHandler.bind(this) );
		Utils.on(window, 'resize', this.siteResizeHandler.bind(this) );

		this.siteScrollHandler();
		this.siteResizeHandler();
	},

	siteScrollHandler: function() {
		let newScrollPos = (document.documentElement.scrollTop||document.body.scrollTop);

		if (newScrollPos < 200 || newScrollPos <= this.scrollTrigger) {
			this.removeClass('is-sticky');
		} else if (newScrollPos > this.lastScrolled && newScrollPos > this.scrollTrigger ) {
			this.scrolledDown += newScrollPos - this.lastScrolled;
			this.addClass('is-sticky');				
			this.scrolledUp = 0;			
		}
		this.lastScrolled = (document.documentElement.scrollTop||document.body.scrollTop);
	},

	siteResizeHandler: function() {
		this.scrollTrigger = this.getCoords(this.el).top;
	},

	getCoords: function(elem) { // crossbrowser version
		let box = elem.getBoundingClientRect();

		let body = document.body;
		let docEl = document.documentElement;

		let scrollTop = window.scrollY || docEl.scrollTop || body.scrollTop;
		let scrollLeft = window.scrollX || docEl.scrollLeft || body.scrollLeft;

		let clientTop = docEl.clientTop || body.clientTop || 0;
		let clientLeft = docEl.clientLeft || body.clientLeft || 0;

		let top  = box.top +  scrollTop - clientTop;
		let left = box.left + scrollLeft - clientLeft;

		return { top: Math.round(top), left: Math.round(left) };
	}

});

(function(){		
	Utils.each(Utils.find('.js--stylish-table'), function(elem) {
		new StylishTable( {el: elem} );
	});
})();

export default StylishTable;